// import React from "react";
// import "./PGSecurityOneHome.scss";
// import SecurityOneVideoSection from "../securityOneComponent/SecurityOneVideoSection";
// import SecurityOneNewVisitorPhoneNumber from "../securityOneComponent/SecurityOneNewVisitorPhoneNumber";
import { useNavigate } from "react-router-dom";
import SecurityOneQuickMenus from "../securityOneComponent/SecurityOneQuickMenus";
import FrontDeskQuickMenus from "./FrontDesk";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
const SecurityOneVisitorService = () => {
  const navigate = useNavigate();
  const { documents: visitorsDocuments } = useCollection("visitors");
  const { documents: userDocuments } = useCollection("users");

  return (
    <div>
      {/* <SecurityOneVideoSection />
      <SecurityOneNewVisitorPhoneNumber />
      <div className="large_margin_div"></div> */}
      <div className="security-one-home-container">
        {/* <div className="security-one-home-banner">
          <HomeHeroBanners
            category="banner"
            pageName="home"
            section="homeherobanners"
            addMoreVideosButton={false}
            addMoreTextContentButton={false}
          />
        </div> */}

        {/* SEARCH SECTION START */}
        <div className="security-one-home-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="gray"
          >
            <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
          </svg>
          <input
            type="search"
            autoComplete=""
            placeholder="Search visitors by name, phone number"
          />
        </div>
        {/* SEARCH SECTION END */}

        <FrontDeskQuickMenus />

        <div className="security-one-home-balance-refer">
          <div>
            <span className="material-symbols-outlined">beach_access</span>
            Holiday List
          </div>
          <div>
            <span className="material-symbols-outlined">card_giftcard</span>
            Refer & Win
          </div>
        </div>

        {/* UPCOMING VISITORS CODE START */}
        <div className="security-one-home-section-title">VISITORS</div>
        <div className="security-one-home-upcoming-visitors">
          {visitorsDocuments &&
            visitorsDocuments.map((visitor, index) => {
              // Match user by phone number
              <p>naman</p>;

              const matchedUser = userDocuments?.find(
                (user) => user.phoneNumber === visitor.phoneNumber
              );
              return (
                <div
                  className="security-one-home-visitor"
                  key={index}
                  onClick={() => navigate(`/visitor-details/${visitor.id}`)}
                >
                  <div>
                    <img
                      src={
                        matchedUser?.registeredFaceUrl ||
                        "/assets/img/men-icon-login.png"
                      }
                      alt={visitor.name}
                    />
                    <div className="security-one-home-visitor-name">
                      {visitor.visitorName}
                    </div>
                  </div>
                </div>
              );
            })}
          <div
            className="security-one-home-upcoming-visitors"
            onClick={() => navigate("/host-home")}
          >
            <div className="security-one-home-visitor">
              <div className="icon-avatar" style={{ background: "#000000ab" }}>
                <span className="material-symbols-outlined">
                  keyboard_arrow_down
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* UPCOMING VISITORS CODE END */}

        <div className="security-one-home-section-title">DISCOVER</div>
        <div className="security-one-home-recharges">
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">person</span>
            Profile
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">notifications</span>
            Notifications
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">settings</span>
            Settings
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">warning</span>
            Support
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityOneVisitorService;
